import { isMobileNumberValid } from '@/utils/shared/is-mobile-number-valid';
import { z } from 'zod';

export const MobileNumberSchema = z.string().refine(isMobileNumberValid, 'Ogiltigt mobilnummer');
